
import { Component, Watch, Vue } from 'vue-property-decorator'
import { useReuseTabStore } from '@/store/reuse-tab'

@Component({
  name: 'MainBread',
  components: {},
})
export default class MainBread extends Vue {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private breadList: any[] = []
  private reuseTabStore = useReuseTabStore()

  @Watch('reuseTabStore.matched')
  private changeSelected() {
    const isMenu = this.reuseTabStore.matched.every((m) => m.meta.isMenu)
    if (isMenu) {
      // 全是菜单直接加进列表
      this.breadList = this.reuseTabStore.matched
    } else {
      const index = this.breadList.findIndex((r) => r.path === this.$route.path)
      if (index === -1) {
        const current = this.reuseTabStore.matched[this.reuseTabStore.matched.length - 1]
        this.breadList.push(
          Object.assign(current, {
            query: this.$route.query,
          }),
        )
      } else {
        this.breadList.splice(index + 1)
      }
    }
  }

  protected created() {
    this.breadList = this.reuseTabStore.matched
  }
}
